export default __webpack_public_path__ + "static/media/1703.f731af66.png";